import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Collapsible from "react-collapsible";
import {
  getMiniProposalsByRef, updateProposalStatus
} from "../../../../domains/proposals/services";
import { ModalAlert } from "../../../components";
import PartialsTab from "./partials-tab";

import "./partial.scss";

const Partials = () => {
  const { t } = useTranslation();
  const [input, setInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);


  useEffect(() => {
    const id = setTimeout(async () => {
      const q = (input || "").trim();
      if (!q) {
        setSuggestions([]);
        return;
      }
      setLoadingSearch(true);
      setErrorMsg(null);
      try {
        const res = await getMiniProposalsByRef(q, {  limit: 5  });
        const items = res && res.data.proposalMeta ? res.data.proposalMeta : res;
        setSuggestions(Array.isArray(items) ? items : []);
        setSelected(null);
      } catch (e) {
        setErrorMsg("Erreur de recherche");
      } finally {
        setLoadingSearch(false);
      }
    }, 250);
    return () => clearTimeout(id);
  }, [input, t]);

  const selectProposal = async (p) => {
    setSelected(p);
    setSuggestions([]);
    setErrorMsg(null);
  };

  const updateStatus = async (next) => {
    if (!selected) return;
    setUpdating(true);
    setErrorMsg(null);
    try {
      const updatedpoposal = await updateProposalStatus(selected.reference, "partiel");
      console.log(updatedpoposal);
      const fresh = await getMiniProposalsByRef(selected.reference);
      const item = fresh && fresh.data.proposalMeta ? fresh.data.proposalMeta : fresh;
      setSelected(item[0]);
      setShowAlertSuccess(true);
    } catch (e) {
      setErrorMsg(t("common:error-update") || "Impossible de mettre à jour le statut");
    } finally {
      setUpdating(false);
    }
  };

  return (
    <Collapsible trigger={"Mise en Partiel"} className="Collapsible" is-closed>
    <section className="quick-edit">
        <label htmlFor="proposal-ref" className="sr-only">
          {"Rechercher une proposition: "}
        </label>
        <div class="search-wrapper">

          <input
            id="proposal-ref"
            type="search"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={"Saisir la référence..."}
            className="input-search"
            autocomplete="off"
          />
          {suggestions.length > 0 && !selected && (
            <ul className="list-search suggestions border rounded mt-2">
              {suggestions.map((p) => (
                <li
                  key={p.id}
                  className="item cursor-pointer"
                  onClick={() => selectProposal(p)}>
                  <div className="">
                    <span className="">{p.reference}</span>
                    <span className="">{" - "}</span>
                    <span className="">{p.status}</span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        {loadingSearch && <p>{"Recherche…"}</p>}
        {errorMsg && <p role="alert" className="text-red-600">{errorMsg}</p>}
        <div className="card border rounded p-3 mt-3">     
          {selected && (
            <div className="space-y-2">           
              <PartialsTab selected={selected} updateStatus={updateStatus} updating={updating}></PartialsTab>
            </div>
          )}

        </div>
 
      <ModalAlert
        visible={showAlertSuccess}
        onCancel={() => {
          setShowAlertSuccess(false);
        }}
        title={t("users:user-menu.success-title")}
        iconConfig="actions-validate"
        cancelButtonText={t("users:user-menu.close")}>
        <p>{t("users:user-menu.successmessage")}</p>
      </ModalAlert>
    </section>     
    </Collapsible>

  );
};
export default Partials;
